import { atom, selector } from "recoil";
import { getAPI, getPlan, getUser, userType } from "lib/store/user";

export const signInState = atom({
  key: "isLogged",
  default: false,
});

export const updatePlan = atom({
  key: "plan_state",
  default: new Date(),
});

export const profileState = atom({
  key: "profile",
  default: {
    id: 0,
    last_login: "",
    email: "",
    username: "",
    social: null,
  } as userType,
});

export const asyncGetProfile = selector({
  key: "USER/profile",
  get: async () => {
    let user: userType = {
      email: "",
      id: 0,
      last_login: "",
      social: null,
      username: "",
    };
    try {
      user = { ...(await getUser()) };
    } catch (e) {
      console.log(e);
    }
    return user;
  },
});

export const asyncGetPlan = selector({
  key: "USER/plan",
  get: async ({ get }) => {
    get(updatePlan);
    let plan;
    try {
      plan = await getPlan();
    } catch (e) {
      console.log(e);
    }

    return plan;
  },
});

export const apiState = atom({
  key: "USER/api",
  default: {
    key: null,
    created: null,
  },
});

export const asyncGetAPI = selector({
  key: "USER/get_api",
  get: async () => {
    let returnVal;

    try {
      returnVal = await getAPI();
    } catch (e) {
      console.log(e);
    }

    return returnVal;
  },
});

//구글 회원가입시 강제로 동의화면으로 넘기기 위한 변수.
export const temporaryUseAccessToken = atom({
  key: "tempGoogleToken",
  default: {} as {
    access_token?: string;
    refresh_token?: string;
    user?: userType & {
      agreement: boolean;
      marketing: boolean;
    };
  },
});
